import { recentDaysPeriodOf, reportPeriodOf } from '../../report-period.ts';

export const OPERATION_PERIODS = [
  'last_7_days',
  'last_30_days',
  'this_month',
  'last_month',
  'this_year',
  'custom',
] as const;

export type OperationPeriod = (typeof OPERATION_PERIODS)[number];

export const DEFAULT_OPERATION_PERIOD: OperationPeriod = 'last_30_days';

export type OperationPeriodChoice = {
  readonly operationPeriod: OperationPeriod;
  readonly operationFrom: string | null;
  readonly operationTo: string | null;
};

export type OperationWindow = { readonly since: string; readonly until: string | null };

const THIRTY_DAYS = 30;

const startOfLocalDay = (day: string, offsetDays = 0): string => {
  const [year = 0, month = 1, date = 1] = day.split('-').map(Number);
  return new Date(year, month - 1, date + offsetDays).toISOString();
};

const presetWindow = (period: Exclude<OperationPeriod, 'custom'>, now: Date): OperationWindow => {
  const span = period === 'last_30_days' ? recentDaysPeriodOf(THIRTY_DAYS, now) : reportPeriodOf(period, now);
  return { since: span.from, until: span.to };
};

export const operationWindowOf = (choice: OperationPeriodChoice, now: Date): OperationWindow | null => {
  if (choice.operationPeriod !== 'custom') return presetWindow(choice.operationPeriod, now);
  if (choice.operationFrom === null) return null;
  return {
    since: startOfLocalDay(choice.operationFrom),
    until: choice.operationTo === null ? null : startOfLocalDay(choice.operationTo, 1),
  };
};
